export enum OperationName {
    PAYOUT = 'payout',
}

export enum TraceHeader {
    OPERATION_ID = 'x-trace-operation-id',
}
